import React, { useState, useEffect } from "react";
import "katex/dist/katex.min.css";
import Latex from "react-latex-next";
import Button from "../../components/common/Button";
import InputBox from "../../components/common/InputBox";
import Div from "../../components/common/Div";
import Text from "../../components/common/Text";
import { Tex } from "react-tex";
import {
  tenzero,
  NumberToLetter,
  fixOptions,
  fixMarginQuestionButtons,
  LetterToNumber,
} from "../../constants/Constants";
import Image from "../../components/common/Image";
import QuestionText from "../Partials/QuestionText";
import {formatLatexText} from "../../utils/formatLaTex";

export default function Q_ColumnMatch(props) {
  const [selectedInput, setSelectedInput] = useState(-1);

  const question = props.question;
  const options = props.options;
  const submission = props.submission;
  const questionNumber = props.questionNumber;
  const setSubmission = props.setSubmission;

  function Setup() {
    let submit = submission;
    let submit2 = MakeBlankArray(options.length);
    if (submit[questionNumber] === undefined) submit[questionNumber] = submit2;
    setSubmission(submit);
  }

  function MakeBlankArray(i) {
    return Array.apply(null, Array(i)).map(function (x, i) {
      return "";
    });
  }

  function onSelected(e) {
    function selectedInputFix(input) {
      let output = parseInt(input) + 1;
      if (output === options.length) output = 0;
      return output;
    }

    if (selectedInput === -1) return;
    let submit = submission;
    let submit2 = MakeBlankArray(options.length);
    if (submit[questionNumber] === undefined)
      submit2 = MakeBlankArray(options.length);
    else submit2 = submit[questionNumber];
    //submit2[selectedInput] = e.target.innerHTML;
    let ansIndex = LetterToNumber(e.target.innerHTML); //Instead, we want the full text of the answer chosen as the answer to be submitted
    submit2[selectedInput] = options[ansIndex].text;

    submit[questionNumber] = submit2;
    setSubmission(submit);
    setSelectedInput(selectedInputFix(selectedInput));
  }

  function onClick(e) {
    const value = e.target.id.substring(5);
    setSelectedInput(value);
  }

  function onClickClear(e) {
    let submit = submission;
    submit[questionNumber] = MakeBlankArray(options.length);
    setSubmission(submit);
    setSelectedInput(-1);
  }

  function Options() {
    let arr = [];
    for (var i = 0; i < options.length; i++) {
      const letter = NumberToLetter(i);

      const getTex = () => {
        const cont = fixOptions("", options[i].text);
        const a = cont.split("\\\\");
        const x = a.map((y) => (
          <div style={{ padding: "5px 0px" }}>
            <Tex texContent={y} />
          </div>
        ));
        return <div>{x.map((a) => a)}</div>;
      };

      const texCon = options[i].text !== null ? getTex() : <></>;

      let formattedText = formatLatexText(options[i].text);

      const value = (
        <div key={"Text".concat(letter)}>
          <div style={{ display: "flex", fontSize: "0.9rem" }}>
            <div
              style={{
                flex: 3,
                textAlign: "right",
                paddingRight: "0.5em",
                paddingTop: "5px",
                fontSize: "0.9rem",
              }}
            >
              <text style={{ fontSize: "0.9rem" }}>{letter.concat(". ")}</text>
            </div>
            <div style={{ flex: 17, textAlign: "left", fontSize: "0.9rem" }}>
              <div style={{ marginTop: "auto", marginBottom: "auto" }}>
                {formattedText && <Latex>{formattedText}</Latex>}
              </div>
              <Image src={options[i].url} width="150px" />
            </div>
          </div>
        </div>
      );
      arr.push(value);
    }
    return <Div>{arr}</Div>;
  }

  function OptionSelectButtons() {
    let arr = [];
    for (var i = 0; i < options.length; i++) {
      const letter = NumberToLetter(i);
      const value = MakeButton(letter, options.length);
      arr.push(value);
    }
    return <Div padding={"0 10px"}>{arr}</Div>;
  }

  function MakeButton(text, numberOption) {
    const width = (window.innerWidth - numberOption * 2 * 3) / 2;
    const buttonWidth = width / numberOption;

    return (
      <Button
        key={"Button".concat(text)}
        onClick={onSelected}
        width={buttonWidth + "px"}
        height={"40px"}
        margin={"2px 3px"}
        backgroundColor={"#00112e"}
        color={"#FFFFFF"}
        borderRadius={"5px"}
        fontWeight={"bold"}
      >
        {text}
      </Button>
    );
  }

  function answerBackToLetter(ansText) {
    return NumberToLetter(options.map((x) => x.text).indexOf(ansText));
  }

  function OptionPlacement() {
    let arr = [];
    for (var i = 0; i < options.length; i++) {

      let formattedText = formatLatexText(options[i].description);

      const value = (
        <div style={{ marginBottom: "15px" }}>
          <Div margin={"0"} key={"Span".concat(i.toString())} display={"flex"}>
            <Div margin={"auto auto auto 35px"} width={"fit-content"}>
              {formattedText && <Latex>{formattedText}</Latex>}
            </Div>
            <div style={{ marginLeft: "5px" }}>
              <Div margin={"auto 35px auto auto"} width={"fit-content"}>
                <InputBox
                  width={"25px"}
                  height={"20px"}
                  textAlign={"center"}
                  border={
                    i == selectedInput ? "1px solid blue" : "1px solid gray"
                  }
                  outline={
                    i == selectedInput ? "1px solid white" : "1px solid gray"
                  }
                  key={"Input".concat(i.toString())}
                  id={"Input".concat(i.toString())}
                  onClick={onClick}
                  readOnly
                  value={
                    submission[questionNumber] === undefined ||
                    submission[questionNumber][i] === undefined
                      ? ""
                      : answerBackToLetter(submission[questionNumber][i])
                  }
                  color={"black"}
                />
              </Div>
            </div>
          </Div>
        </div>
      );
      arr.push(value);
    }
    arr.push(
      <Div margin={"5px 0"} key={"SpanClearAll"}>
        <Button
          key={"ClearAllButton"}
          onClick={onClickClear}
          width={"15%"}
          height={"40px"}
          margin={"2px 3px"}
          backgroundColor={"#00112e"}
          color={"#FFFFFF"}
          borderRadius={"5px"}
          fontWeight={"bold"}
        >
          Clear All
        </Button>
      </Div>
    );
    return (
      <Div display={"flex"} flexDirection={"column"}>
        {arr}
      </Div>
    );
  }

  useEffect(() => {
    const abortController = new AbortController();
    Setup();
    setSelectedInput(0);
    return () => {
      abortController.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Div height={"100%"} width={"100%"}>
      <Div overflowY={"auto"} height={"80%"}>
        <QuestionText question={question} />
        <Image src={question.url} width="200px" />
        {Options()}
        {OptionPlacement()}
      </Div>
      <Div
        margin={fixMarginQuestionButtons(options.length)}
        bottom={"0"}
        position={"relative"}
      >
        {OptionSelectButtons()}
      </Div>
    </Div>
  );
}
